export const BookingTypes = {
    COVID_FLU_CODE: 'COVID_FLU',
    MMR_CODE: 'MMR',
    PERTUSSIS_CODE: 'PERTUSSIS',
    RSV_CODE: 'RSV',
    MENB_CODE: 'MENB'
}
